<template>
    <v-row justify="center">
        <v-dialog
            class="department-modal"
            v-model="dialog"
            persistent
            max-width="370">
            <v-card>
                <div class="modal-close-btn">
                    <div class="cross-style" @click="closeModal()">
                        x
                    </div>
                </div>
                <div class="modal-content">
                    <v-card-title class="center pt-0">
                        {{ title }}
                    </v-card-title>
                    <v-form
                        lazy-validation
                        ref="form"
                        v-model="valid">
                        <v-text-field
                            :label="$vuetify.lang.t('$vuetify.departmemtFormModal.departmentName')"
                            v-model="form.name"
                            placeholder=" "
                            autocomplete="off"
                            :rules="inputRules"
                            :error-messages="errors.name">
                        </v-text-field>
                        <v-textarea
                            class="d-text-area"
                            :label="$vuetify.lang.t('$vuetify.departmemtFormModal.description')"
                            :maxlength="255"
                            v-model="form.description"
                            placeholder=" "
                            rows="2"
                            no-resize counter>
                        </v-textarea>

                        <span class="bold locale-font">
                            {{ $vuetify.lang.t('$vuetify.departmemtFormModal.managerInformation') }}
                        </span>

                        <v-text-field
                            :label="$vuetify.lang.t('$vuetify.departmemtFormModal.fullName')"
                            v-model="form.manager"
                            placeholder=" "
                            autocomplete="off"
                            :rules="inputRules">
                        </v-text-field>
                        <v-text-field
                            :label="$vuetify.lang.t('$vuetify.departmemtFormModal.eamilAddress')"
                            v-model="form.manager_contact"
                            placeholder=" "
                            autocomplete="off"
                            :rules="emailRules">
                        </v-text-field>
                        <v-text-field
                            v-model="phoneNumberMask"
                            :label="$vuetify.lang.t('$vuetify.departmemtFormModal.phoneNumber')"
                            :prefix="`(${nationalTelCode})`"
                            :rules="phoneRules"
                            placeholder="00 000 0000"
                            autocomplete="off"
                            v-mask = "'## ### ####'">
                        </v-text-field>
                    </v-form>
                </div>
                <div class="modal-save-btn">
                    <v-btn
                        width="200"
                        color="primary"
                        @click="submitForm()">
                        {{ $vuetify.lang.t('$vuetify.departmemtFormModal.save') }}
                    </v-btn>
                </div>
                <v-card-actions>
                    <v-spacer />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mask } from 'vue-the-mask'

export default {
    name: 'DepartmemtFormModal',

    directives: {
        mask
    },

    data () {
        return {
            dialog: false,
            isEdit: false,
            title: '',
            valid: true,
            departmentId: null,
            form: {
                name: '',
                description: '',
                manager: '',
                manager_contact: '',
                contact_no: ''
            },
            phoneNumberMask: '',
            inputRules: [
                v => this.$validator.hasValue(v, this.trans.departmemtFormModal.thisFieldIsRequired),
                v => this.$validator.lengthNotExceed(v, 255, this.trans.departmemtFormModal.thisFieldIsExceededCharacters)
            ],
            phoneRules: [
                v => this.$validator.lengthExactly(v, 11, this.trans.departmemtFormModal.incorrectPhoneNubmer)
            ],
            nationalTelCode: '+66',
            emailRules: [
                vmail => this.$validator.hasValue(vmail, this.trans.departmemtFormModal.emailIsRequired),
                vmail => this.$validator.lengthNotExceed(vmail, 255, this.trans.departmemtFormModal.emailIsExceededCharacters),
                vmail => this.$validator.correctFormat(vmail, /.+@.+\..+/, this.trans.departmemtFormModal.invalidEmailFormat)
            ],
            errors: {}
        }
    },

    methods: {
        openModal (department = null) {
            this.dialog = true
            if (department) {
                this.isEdit = true
                this.title = this.$vuetify.lang.t('$vuetify.departmemtFormModal.editDepartment')
                for (const key in this.form) {
                    if (department[key]) {
                        if (key === 'contact_no') {
                            this.phoneNumberMask = department[key].substr(4)
                        } else {
                            this.form[key] = department[key]
                        }
                    }
                }

                if (department.id) {
                    this.departmentId = department.id
                }
            } else {
                this.isEdit = false
                this.title = this.$vuetify.lang.t('$vuetify.departmemtFormModal.createNewDepartment')
            }
        },

        closeModal () {
            this.dialog = false
            this.departmentId = null
            this.form = {
                name: '',
                description: '',
                manager: '',
                manager_contact: '',
                contact_no: ''
            }
            this.phoneNumberMask = ''
            this.errors = {}
            this.$refs.form.resetValidation()
        },

        cleanForm () {
            const keys = ['name', 'description', 'manager', 'manager_contact']
            for (let i = 0; i < keys.length; i++) {
                this.form[keys[i]] = this.form[keys[i]].trim()
            }
        },

        async submitForm () {
            if (!this.$refs.form.validate()) {
                return
            }

            this.cleanForm()

            if (this.isEdit) {
                await this.updateDepartment()
            } else {
                await this.createDepartment()
            }
        },

        async createDepartment () {
            this.$store.dispatch('setLoading', true)
            this.form.contact_no = `${this.nationalTelCode} ${this.phoneNumberMask}`

            const res = await this.axios.post('department/create', this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-created')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: this.trans.departmemtFormModal.congratulation,
                    text: this.trans.departmemtFormModal.departmentIsCreated,
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.trans.departmemtFormModal.errorMessage,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        },

        async updateDepartment () {
            this.$store.dispatch('setLoading', true)
            this.form.contact_no = `${this.nationalTelCode} ${this.phoneNumberMask}`

            const res = await this.axios.put(`department/edit/${this.departmentId}`, this.form)
            if (res && res.data && res.data.status === 'ok') {
                this.$emit('success-updated')
                this.closeModal()
                this.$store.dispatch('setLoading', false)

                this.$notify({
                    title: this.trans.departmemtFormModal.congratulation,
                    text: this.trans.departmemtFormModal.departmentIsUpdated,
                    type: 'success'
                })
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.trans.departmemtFormModal.errorMessage,
                        text: this.errors[property],
                        type: 'error'
                    })
                }
            }
        }
    },

    async mounted () {
        this.registerLang({
            departmemtFormModal: [
                'thisFieldIsRequired',
                'thisFieldIsExceededCharacters',
                'incorrectPhoneNubmer',
                'emailIsRequired',
                'invalidEmailFormat',
                'emailIsExceededCharacters',
                'congratulation',
                'departmentIsCreated',
                'departmentIsUpdated',
                'errorMessage'
            ]
        })
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                if (this.dialog) {
                    this.$refs.form.resetValidation()
                }
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.department-modal-divider {
    .theme--light, .v-divider {
        border-color: rgb(148 148 148);
    }
}
</style>
